import React from 'react'
import PropTypes from 'prop-types'
import DataSource from '../DataSource'
import ModuleWithLoader from '../components/ModuleWithLoader'
import TermsOfUseCheckbox from '../components/TermsOfUseCheckbox'
import TermsAndConditionsCheckbox from '../components/TermsAndConditionsCheckbox'
import FormHOC from './FormHOC'
import Button from '../elements/Button'
import FancySelectAdvancedRow from '../elements/FancySelectAdvancedRow'
import { NETWORK_TELSTRA, SERVICE_MOBILE } from '../constants'
import store from '../store'
import ComparePlans from '../components/ComparePlans/ComparePlans'
import globals from '../globals'
import MobilePlanAdditionalData from '../components/MobilePlanAdditionalData'
import MobilePlanAdditionalText from '../components/MobilePlanAdditionalText'
import Addressify from '../elements/Addressify'
import CustomLink from '../components/CustomLink'
import { connect } from 'react-redux'
import InputRow from '../elements/InputRow'
import Checkbox from '../elements/Checkbox'
import IdCheckForm from '../components/IdCheckForm'

const options = {
    postUrl: '/api/postMigrateMobile',
    success: 'Your mobile service has been scheduled for migration. Have another mobile? <a href="/migrate-mobile" class="color-indigo underline">Click here</a> to migrate more.'
}
const state = {
    serviceId: null,
    planId: null,
    deliveryFirstName: '',
    deliveryLastName: '',
    deliveryCompany: '',
    deliveryAddress: '',
    homeAddress: '',
    firstName: '',
    middleName: '',
    lastName: '',
    fullName: '',
    dateOfBirth: '',
    idType: '',
    idNumber: '',
    idState: '',
    country: '',
    individualRefNumber: '',
    cardType: '',
    cardNumber: '',
    idExpiry: '',
    idCheckAgree: false,
    termsOfUse: false,
    termsAndConditions: false,
    validIdCheck: '',
    referrerCode: ''
}

class MigrateMobileForm extends React.Component {
    // todo: Refreshes plan state on 422 error - need to fix

    constructor (props) {
        super(props)

        this.state = {
            isLoadingPlans: false,
            hasError: false,
            plans: [],
            currentPlan: {},
            currentService: {}
        }
    }

    componentDidMount () {
        this.props.setDynamicValues({
            customerId: store.getState().auth.id,
            serviceId: this.props.values.serviceId,
            validIdCheck: this.props.validIdCheck,
            idCheckAgree: this.props.validIdCheck, // Accept the checkbox for validation
            dateOfBirth: this.props.validIdCheck ? '01/01/1990' : '' // Hack - validation
        }, () => {
            this.selectPhoneIfSingle()
            this.selectPhoneIfDefault()
        })
    }

    componentDidUpdate (prevProps, prevState, snapshot) {
	    if (this.props.validIdCheck !== prevProps.validIdCheck) {
            this.props.setDynamicValues({
                validIdCheck: this.props.validIdCheck,
                idCheckAgree: this.props.validIdCheck,
                dateOfBirth: this.props.validIdCheck ? '01/01/1990' : '' // Hack - validation
            })
        }
    }

    selectPhoneIfDefault () {
        if (this.props.values.serviceId) {
            const matchingPlans = this.props.numbers.filter(item => item.value.id === this.props.values.serviceId)
            if (matchingPlans[0]) {
                const plan = matchingPlans[0].value
                this.props.setDynamicValues({
                    phoneData: plan
                }, () => {
                    this.handleChangePhone({ phoneData: plan })
                })
            }
        }
    }

    selectPhoneIfSingle () {
        if (this.props.numbers.length === 1) {
            const onlyPhone = this.props.numbers[0].value
            this.props.setDynamicValues({
                phoneData: onlyPhone
            }, () => {
                this.handleChangePhone({ phoneData: onlyPhone })
            })
        }
    }

    handleChangePhone (data) {
        this.props.setDynamicValues({ serviceId: data.phoneData.id })
        this.setState({
            plans: [],
            currentService: data.phoneData
        }, () => this.getPlans(data.phoneData.id))
    }

    getPlans (serviceId) {
	    this.setState({
            isLoadingPlans: true,
            hasError: false
        })
        DataSource.getData(`/api/getMobileMigrationPlans/${serviceId}`, result => {
            this.setState({
                isLoadingPlans: false,
                plans: result.plans,
                currentPlan: result.plans[2]
            }, () => {
                if (this.props.values.planId) {
                    this.handleChangePlan(this.props.values.planId)
                }
            })
        }, error => {
            this.setState({
                hasError: true,
                isLoadingPlans: false
            })
        })
    }

    handleChangePlan (id) {
        this.props.setDynamicValues({
            planId: id
        }, this.setCurrentPlan.bind(this))
    }

    handleChange (event) {
        this.props.handleInputChange(event)
    }

    handleBlurFirstName () {
        if (!this.props.values.deliveryFirstName) {
            this.props.setDynamicValues({ deliveryFirstName: this.props.values.firstName })
        }
    }

    handleBlurLastName () {
        if (!this.props.values.deliveryLastName) {
            this.props.setDynamicValues({ deliveryLastName: this.props.values.lastName })
        }
    }

    handleChangeIdType (value) {
        this.props.setDynamicValues({
            idType: value,
            idNumber: '',
            idState: '',
            country: '',
            individualRefNumber: '',
            cardType: '',
            idExpiry: '',
            cardNumber: ''
        })
    }

    handleChangeDob (event) {
	    const target = event.target
	    this.props.setDynamicValues({
            dateOfBirth: target.value.replaceAll(' ', '')
        })
    }

    setCurrentPlan () {
        this.state.plans.map(plan => {
            if (this.props.values.planId === plan.id) {
                this.setState({ currentPlan: plan })
            }
        })
    }

    mapExistingPlanFields () {
        return {
            title: this.state.currentService.title,
            data: <span className='bold'>{this.state.currentService.data}</span>,
            dataAdditional: '',
            price: this.state.currentService.price,
            features: this.state.currentService.features
        }
    }

    mapApiPlanFields () {
        const plans = []

        this.state.plans.forEach(plan => {
            const additionalText1 = plan.features.length >= 3 ? <MobilePlanAdditionalText content={[plan.features[1], plan.features[2]]} /> : ''
            const additionalText2 = plan.features.length >= 4 ? <MobilePlanAdditionalText content={plan.features[3] ? [plan.features[3]] : []} /> : ''

            plans.push({
                id: plan.id,
                title: plan.title,
                data: <span className='bold'>{plan.data}</span>,
                dataAdditional: <MobilePlanAdditionalData content={plan.dataAdditional} />,
                special: plan.special ? plan.special : null,
                price: plan.price,
                features: plan.features[0] ? [plan.features[0]] : [],
                additionalText1: additionalText1,
                additionalText2: additionalText2,
                costPerGb: plan.costPerGb,
                totalMinCost: plan.id !== 413 ? '0' : plan.price
            })
        })

        return plans
    }

    render () {
        return (
            <div className='migrate-mobile-form'>
                <div className='row mb-lg-2'>
                    <div className='col-12 col-lg-8 offset-lg-2 phone-select'>
                        {this.props.numbers.length > 0
                            ? <FancySelectAdvancedRow
                                    label={globals.noWidows('Select the mobile service you would like to migrate')}
                                    name='phoneData'
                                    options={this.props.numbers}
                                    value={this.props.values.phoneData}
                                    handleChange={this.handleChangePhone.bind(this)}
                            />
                            : <p className='text-center'>Your account has no active Exetel mobile services which need to be migrated.</p>}
                    </div>
                </div>

                <div className='row'>
                    <div className='col-12 col-lg-8 offset-lg-2 mb-3'>
                        {this.props.children}
                    </div>
                </div>

                <ModuleWithLoader isLoaded={!this.state.isLoadingPlans} hasError={this.state.hasError}>
                    {this.state.plans.length > 0
                        ? <React.Fragment>
                            {/* <Breadcrumbs /> */}
                            <div className='row'>
                                <div className='col-12 col-lg-12 px-2 px-lg-4'>
                                    <h2 className='text-center' dangerouslySetInnerHTML={{ __html: globals.noWidows('Choose your mobile plan below') }} />
                                    <ComparePlans
                                        type={SERVICE_MOBILE}
                                        mobileNetwork={NETWORK_TELSTRA}
                                        plans={this.mapApiPlanFields()}
                                        existingPlan={this.mapExistingPlanFields()}
                                        handleSelect={this.handleChangePlan.bind(this)}
                                        selectedPlanId={this.state.currentPlan.id}
                                    />
                                </div>
                            </div>
                            <div className='col-12 col-md-12 d-flex justify-content-center justify-content-md-center align-items-center'>
                                <CustomLink to='https://www.exetel.com.au/mobilephone/charges' className='color-grey underline'>View Rate Card</CustomLink>
                            </div>
                            <div className='row mt-3'>
                                <div className='col-12 col-lg-8 offset-lg-2'>
                                    <div>
                                        <label className='bold mb-3 d-inline-block'>Delivery details</label>
                                        <div className='delivery-name'>
                                            <div>
                                                <p className='font-small sub-bold m-0 mb-1'>First name</p>
                                                <InputRow
                                                    name='deliveryFirstName'
                                                    value={this.props.values.deliveryFirstName}
                                                    errors={this.props.errors}
                                                    handleChange={this.handleChange.bind(this)}
                                                    placeholder='First name'
                                                    hideLabel
                                                />
                                            </div>
                                            <div>
                                                <p className='font-small sub-bold m-0 mb-1'>Last name</p>
                                                <InputRow
                                                    name='deliveryLastName'
                                                    value={this.props.values.deliveryLastName}
                                                    errors={this.props.errors}
                                                    handleChange={this.handleChange.bind(this)}
                                                    placeholder='Last name'
                                                    hideLabel
                                                />
                                            </div>
                                            <div>
                                                <p className='font-small sub-bold m-0 mb-1'>Company name (if applicable)</p>
                                                <InputRow
                                                    name='deliveryCompany'
                                                    value={this.props.values.deliveryCompany}
                                                    errors={this.props.errors}
                                                    handleChange={this.handleChange.bind(this)}
                                                    placeholder='Company name (if applicable)'
                                                    hideLabel
                                                />
                                            </div>
                                        </div>
                                        <Addressify
                                            label='Home address'
                                            name='homeAddress'
                                            value={this.props.values.homeAddress}
                                            errors={this.props.errors}
                                            handleSetAddress={this.props.setDynamicValues}
                                            placeholder='Start typing your home address'
                                        >
                                            <small>So emergency services can find you if you call</small>
                                        </Addressify>
                                        <Addressify
                                            label='Delivery address'
                                            name='deliveryAddress'
                                            value={this.props.values.deliveryAddress}
                                            errors={this.props.errors}
                                            handleSetAddress={this.props.setDynamicValues}
                                            placeholder='If different from home address above'
                                        >
                                            <small>We can't deliver to a PO Box</small>
                                        </Addressify>
                                    </div>
                                </div>
                            </div>
                            <div className='row my-3'>
                                <div className='col-12 col-lg-8 offset-lg-2'>
                                    <TermsOfUseCheckbox
                                        errors={this.props.errors}
                                        value={this.props.values.termsOfUse}
                                        handleClick={value => this.props.setDynamicValues({ termsOfUse: value })}
                                        cisUrl={this.state.currentPlan.cisLink ? this.state.currentPlan.cisLink : 'https://files.exetel.com.au/cis/mobile/2025-01-23/Exetel_Prepaid_Mobile_CIS.pdf'}
                                        termsUrl='https://www.exetel.com.au/mobilephone/faq-terms'
                                    >
                                        I have less than 5 pre-paid mobile services and&nbsp;
                                    </TermsOfUseCheckbox>
                                    <br />
                                    <TermsAndConditionsCheckbox
                                        errors={this.props.errors}
                                        value={this.props.values.termsAndConditions}
                                        handleClick={value => this.props.setDynamicValues({ termsAndConditions: value })}
                                        type={SERVICE_MOBILE}
                                    />
                                    <br />
                                </div>
                            </div>
                            <div className='row my-4'>
                                <div className='col-12 col-md-4 col-lg-4 offset-md-2 text-center text-lg-left my-2'>
                                    <Button title='Order new plan & SIM' action={this.props.handleSubmit} />
                                </div>
                                <div className='col-8 col-md-3 offset-lg-2 col-lg-2 align-items-center offset-2 offset-md-3'>
                                    <InputRow
                                        name='referrerCode'
                                        value={this.props.values.referrerCode}
                                        errors={this.props.errors}
                                        handleChange={this.handleChange.bind(this)}
                                        placeholder='Referrer Code'
                                        hideLabel
                                    />
                                </div>
                            </div>
                        </React.Fragment>
                        : ''}
                </ModuleWithLoader>
            </div>
        )
    }
}

MigrateMobileForm.propTypes = {
    numbers: PropTypes.array.isRequired
}

const mapStateToProps = state => ({
    firstName: state.auth.firstName,
    lastName: state.auth.lastName,
    validIdCheck: state.auth.validIdCheck
})

export default connect(mapStateToProps, {})(FormHOC(MigrateMobileForm, state, options))



// WEBPACK FOOTER //
// ./resources/js/forms/MigrateMobileForm.js